import { IRules, RuleBlock } from './CssRules.Contract';

export function getCss(rules: RuleBlock | IRules): string {
	if(!rules) {
		return '';
	}

	return Object.entries(rules).map(([property, value]) => {
		if(typeof value === 'string' || typeof value === 'number') {
			return `${property}:${value};`;
		}
		return `${property} {${getCss(value)}}`;
	})
		.join('');
}

export function appendStyles(): CSSStyleSheet {
	const style = new CSSStyleSheet();
	document.adoptedStyleSheets.push(style);
	return style;
}

export function applyStyles(style: CSSStyleSheet, rules: IRules): void {
	style?.replaceSync(getCss(rules));
}

export function removeStyle(style: CSSStyleSheet): void {
	if(style) {
		document.adoptedStyleSheets = document.adoptedStyleSheets.filter(s => s !== style);
	}
}
